<template>
    <b-form-group :label="label" label-for="target">
        <b-form-input
            id="target"
            :value="value"
            :state="state"
            @input="$emit('update:value', $event)"
            :placeholder="placeholder"
            aria-describedby="target-feedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="target-feedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
export default {
    name: 'Target',
    props: ['value', 'state', 'disabled', 'placeholder', 'label'],
}
</script>
